import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function ParticipantInfo({ label, name, phone }) {
  return (
    <div className="flex w-full flex-row justify-between">
      <Typography className="w-1/2 text-[14px]" style={{ color: HNSColors.neutrals[300] }}>
        <span className="font-semibold">{label}: </span>
        {name}
      </Typography>
      <Typography className="w-1/2 text-[14px]" style={{ color: HNSColors.neutrals[300] }}>
        <span className="font-semibold">Phone: </span>
        {phone}
      </Typography>
    </div>
  );
}
